import { createActionCreator } from 'deox';
import { SiteMetadata } from '@/types';

export const fetchSiteMetadataActions = {
  request: createActionCreator('FETCH_SITE_METADATA_REQUEST', (resolve) => (subdomain: string) =>
    resolve({ subdomain }),
  ),
  success: createActionCreator(
    'FETCH_SITE_METADATA_SUCCESS',
    (resolve) => (metadata: SiteMetadata) => resolve({ metadata }),
  ),
  failure: createActionCreator('FETCH_SITE_METADATA_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
